export const search = {
  pathname: '/api/dashboard/delightfulsearch/query',
  method: 'POST',
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json'
  },
  body: query => (query)
}
